import { useEffect, useRef } from "react";
import { Flex, Form, Checkbox } from "antd"
import { QuestionCircleOutlined } from "@ant-design/icons"
import { getActiveSetValue, getConditionalRevertValue, shouldRevertConditionalValue } from "../../../utils/formsHelper";

const CheckboxInput = (props) => {
    const { label, tooltip, helpText, mandatory, readOnly, id, form, setValueData } = props
    const rules = mandatory ? [{ required: true }] : undefined;
    const help = tooltip ? { title: helpText, icon: <QuestionCircleOutlined /> }
        : undefined;

    let activeSetValue = getActiveSetValue(setValueData, true)

    // Track the condition value already applied so an editable field is prefilled
    // only once. Read-only fields stay locked to the condition value.
    const lastAppliedConditionalRef = useRef(undefined)

    useEffect(() => {
        if (activeSetValue?.value) {
            const key = activeSetValue.value
            if (readOnly) {
                const current = form?.getFieldValue(id)
                if (current !== key) {
                    form?.setFieldValue(id, key)
                }
            } else if (lastAppliedConditionalRef.current !== key) {
                form?.setFieldValue(id, key)
            }
            lastAppliedConditionalRef.current = key
        } else if (shouldRevertConditionalValue(activeSetValue, { disabled: readOnly, currentValue: form?.getFieldValue(id), appliedValue: lastAppliedConditionalRef.current })) {
            form?.setFieldValue(id, getConditionalRevertValue(id, props.defaultFormValues))
            lastAppliedConditionalRef.current = undefined
        } else {
            lastAppliedConditionalRef.current = undefined
        }
    }, [activeSetValue, form, id, readOnly])

    return (
        <div className="form-element">
            <Form.Item name={id} label={label} tooltip={help} rules={rules} valuePropName="checked" className="horizontal-form-item form-checkbox" >
                <Checkbox disabled={readOnly} />
            </Form.Item>
        </div>
    )
}

export default CheckboxInput